var map = {
	"./Leopard Family Eating Pray [REDUCED].m4v": 1520,
	"./Leopard Hunt [REDUCED].m4v": 1521,
	"./Mother calling cubs [REDUCED].m4v": 1522,
	"./Sibling Behaviour [STICHED][REDUCED].m4v": 1523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1371;